import type { IContextQueryResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';

import type { ISettingsEmailsListResponse } from '../types';
import {
  ADMIN_GENERAL_SETTINGS_EMAILS_PERMISSIONS,
  SETTINGS_EMAIL_TRIGGERS_LIST_QUERY_KEY,
  SETTINGS_EMAIL_TRIGGERS_LIST_URL,

} from '../constants';

export default function useSettingsEmailTriggersListQuery(): IContextQueryResult<ISettingsEmailsListResponse> {
  const { fetchGet } = useRestClient();

  return useContextQuery<ISettingsEmailsListResponse, Error>({
    queryKey: [SETTINGS_EMAIL_TRIGGERS_LIST_QUERY_KEY],
    queryFn: ({ signal }) => fetchGet(SETTINGS_EMAIL_TRIGGERS_LIST_URL, {
      signal,
      permission: ADMIN_GENERAL_SETTINGS_EMAILS_PERMISSIONS.MAILERS_MANAGER_EDIT,
    }),
  });
}
